import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createObstetricsDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterObstetricsFormSchema } from "./schema";
import { DischargeLetterObstetricsFormSections } from "./sections";

export const getDischargeLetterObstetricsFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        anamnesis: value?.anamnesis ?? "",
        course_of_labor: value?.course_of_labor ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        discharge_status: value?.discharge_status ?? "",
        discharge_summary: value?.discharge_summary ?? "",
        information_newborn: value?.information_newborn ?? "",
        lab_results: value?.lab_results ?? "",
        physical_status: value?.physical_status ?? "",
        postpartum_recovery: value?.postpartum_recovery ?? "",
        recommendations: value?.recommendations ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formObstetrics.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameObstetrics,
      pdfCreator: createObstetricsDischargeLetterPdf,
    },
    schema: DischargeLetterObstetricsFormSchema,
    sections: DischargeLetterObstetricsFormSections,
  };
};
